import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum InstitutionStatus {
    UNTOUCHED, PENDING, IN_PROGRESS, INACTIVE, ACTIVE, DECLINED, NO_TEACHER, POTENTIAL,
}

export namespace InstitutionStatus {
    type Data = { text: string, icon: string, color: string };

    export const Record: Record<InstitutionStatus, Data> = {
        [InstitutionStatus.UNTOUCHED]: {
            text: 'Unberührt',
            icon: 'mdi-vibrate-off',
            color: 'grey',
        },
        [InstitutionStatus.PENDING]: {
            text: 'Ausstehend',
            icon: 'mdi-account-clock',
            color: 'warning',
        },
        [InstitutionStatus.IN_PROGRESS]: {
            text: 'In Arbeit',
            icon: 'mdi-briefcase',
            color: 'info',
        },
        [InstitutionStatus.INACTIVE]: {
            text: 'Inaktiv',
            icon: 'mdi-account-off',
            color: 'grey',
        },
        [InstitutionStatus.ACTIVE]: {
            text: 'Aktiv',
            icon: 'mdi-check',
            color: 'success',
        },
        [InstitutionStatus.DECLINED]: {
            text: 'Abgesagt',
            icon: 'mdi-cancel',
            color: 'error',
        },
        [InstitutionStatus.NO_TEACHER]: {
            text: 'Keine Lehrkraft',
            icon: 'mdi-human-male-board',
            color: 'error',
        },
        [InstitutionStatus.POTENTIAL]: {
            text: 'Potentieller Standort',
            icon: 'mdi-room-service',
            color: 'indigo',
        },
    };

    export const Items = mapRecordToItems(Record);
}
